import React from "react";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";

import NavBarDesktop from "./NavBar/NavBarDesktop";
import NavBarMobile from "./NavBar/NavBarMobile";
import { useQueryClient } from '@tanstack/react-query'

const NavBar = () => {
	const queryClient = useQueryClient();

	const logout = () => {
		queryClient.invalidateQueries()
		localStorage.clear();
		window.location = "/";
	};

	return (
		<AppBar position="static" color="default" elevation={0}>
			<Container maxWidth="lg">
				<Toolbar disableGutters>
					<NavBarDesktop logout={logout} />

					<NavBarMobile logout={logout} />
				</Toolbar>
			</Container>
		</AppBar>
	);
};

export default NavBar;
